// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.alert-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9998;
  backdrop-filter: blur(2px);
}

.alert-dialog {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: var(--color-bg-card, #1e1e1e);
  border: 2px solid;
  border-radius: 12px;
  padding: 30px;
  min-width: 320px;
  max-width: 500px;
  box-shadow: 0 12px 48px rgba(0, 0, 0, 0.6);
  z-index: 9999;
  animation: alertSlideIn 0.25s ease-out;
  display: flex;
  gap: 20px;
  align-items: flex-start;
}

@keyframes alertSlideIn {
  from {
    opacity: 0;
    transform: translate(-50%, -45%);
  }
  to {
    opacity: 1;
    transform: translate(-50%, -50%);
  }
}

/* Alert type colors */
.alert-success {
  border-color: var(--wylie-green, #1c5f36);
}

.alert-error {
  border-color: var(--wylie-coral, #f05f57);
}

.alert-info {
  border-color: var(--wylie-purple, #50076d);
}

/* Icon styling */
.alert-icon {
  font-size: 28px;
  font-weight: bold;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.alert-success .alert-icon {
  background-color: var(--wylie-green, #1c5f36);
  color: white;
}

.alert-error .alert-icon {
  background-color: var(--wylie-coral, #f05f57);
  color: white;
}

.alert-info .alert-icon {
  background-color: var(--wylie-purple, #50076d);
  color: white;
}

/* Content styling */
.alert-content {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.alert-message {
  color: var(--color-text-light, #e5e7eb);
  font-size: 15px;
  line-height: 1.6;
  white-space: pre-line;
}

/* Outlined like App.css's buttons, in the alert's colour. */
.alert-close-btn {
  align-self: flex-end;
  padding: 10px 30px;
  background-color: transparent;
  border: 1px solid var(--btn-color);
  border-radius: 6px;
  color: var(--btn-color);
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  transition: all 0.2s;
  min-width: 80px;
}

.alert-close-btn:hover {
  background-color: var(--btn-color);
  color: var(--btn-on-color);
}

.alert-success .alert-close-btn {
  --btn-color: var(--part4-color);
  --btn-on-color: #1f1f1f;
}

.alert-error .alert-close-btn {
  --btn-color: var(--wylie-coral, #f05f57);
  --btn-on-color: white;
}

.alert-info .alert-close-btn {
  --btn-color: var(--part5-color);
  --btn-on-color: white;
}

.alert-close-btn:focus {
  outline: 2px solid currentColor;
  outline-offset: 2px;
}
`, "",{"version":3,"sources":["webpack://./src/components/AlertDialog.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,+CAA+C;EAC/C,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;EAC1C,aAAa;EACb,sCAAsC;EACtC,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE;IACE,UAAU;IACV,gCAAgC;EAClC;EACA;IACE,UAAU;IACV,gCAAgC;EAClC;AACF;;AAEA,sBAAsB;AACtB;EACE,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,6CAA6C;EAC7C,YAAY;AACd;;AAEA;EACE,6CAA6C;EAC7C,YAAY;AACd;;AAEA;EACE,8CAA8C;EAC9C,YAAY;AACd;;AAEA,oBAAoB;AACpB;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,4DAA4D;AAC5D;EACE,oBAAoB;EACpB,kBAAkB;EAClB,6BAA6B;EAC7B,kCAAkC;EAClC,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;EAC/B,uBAAuB;AACzB;;AAEA;EACE,wCAAwC;EACxC,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;AACrB","sourcesContent":[".alert-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 9998;\n  backdrop-filter: blur(2px);\n}\n\n.alert-dialog {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background-color: var(--color-bg-card, #1e1e1e);\n  border: 2px solid;\n  border-radius: 12px;\n  padding: 30px;\n  min-width: 320px;\n  max-width: 500px;\n  box-shadow: 0 12px 48px rgba(0, 0, 0, 0.6);\n  z-index: 9999;\n  animation: alertSlideIn 0.25s ease-out;\n  display: flex;\n  gap: 20px;\n  align-items: flex-start;\n}\n\n@keyframes alertSlideIn {\n  from {\n    opacity: 0;\n    transform: translate(-50%, -45%);\n  }\n  to {\n    opacity: 1;\n    transform: translate(-50%, -50%);\n  }\n}\n\n/* Alert type colors */\n.alert-success {\n  border-color: var(--wylie-green, #1c5f36);\n}\n\n.alert-error {\n  border-color: var(--wylie-coral, #f05f57);\n}\n\n.alert-info {\n  border-color: var(--wylie-purple, #50076d);\n}\n\n/* Icon styling */\n.alert-icon {\n  font-size: 28px;\n  font-weight: bold;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.alert-success .alert-icon {\n  background-color: var(--wylie-green, #1c5f36);\n  color: white;\n}\n\n.alert-error .alert-icon {\n  background-color: var(--wylie-coral, #f05f57);\n  color: white;\n}\n\n.alert-info .alert-icon {\n  background-color: var(--wylie-purple, #50076d);\n  color: white;\n}\n\n/* Content styling */\n.alert-content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.alert-message {\n  color: var(--color-text-light, #e5e7eb);\n  font-size: 15px;\n  line-height: 1.6;\n  white-space: pre-line;\n}\n\n/* Outlined like App.css's buttons, in the alert's colour. */\n.alert-close-btn {\n  align-self: flex-end;\n  padding: 10px 30px;\n  background-color: transparent;\n  border: 1px solid var(--btn-color);\n  border-radius: 6px;\n  color: var(--btn-color);\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 600;\n  transition: all 0.2s;\n  min-width: 80px;\n}\n\n.alert-close-btn:hover {\n  background-color: var(--btn-color);\n  color: var(--btn-on-color);\n}\n\n.alert-success .alert-close-btn {\n  --btn-color: var(--part4-color);\n  --btn-on-color: #1f1f1f;\n}\n\n.alert-error .alert-close-btn {\n  --btn-color: var(--wylie-coral, #f05f57);\n  --btn-on-color: white;\n}\n\n.alert-info .alert-close-btn {\n  --btn-color: var(--part5-color);\n  --btn-on-color: white;\n}\n\n.alert-close-btn:focus {\n  outline: 2px solid currentColor;\n  outline-offset: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
